import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { NavigateFunction } from 'react-router-dom';

let navigate: NavigateFunction | null = null;

export const setGlobalNavigate = (navFn: NavigateFunction) => {
  navigate = navFn;
};

export const globalNavigate = (path: string, options?: { replace?: boolean; state?: any }) => {
  if (navigate) {
    navigate(path, options);
  } else {
    console.error('Navigate function is not set. Ensure it is initialized properly.');
  }
};

const NavigationInitializer: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  return null;
};

export default NavigationInitializer;
